import { useEffect, useRef } from 'react';

function LandingDialog({
    open,
    onClose,
    className,
    labelledBy,
    id,
    children,
}) {
    const dialogRef = useRef(null);

    useEffect(() => {
        const dialog = dialogRef.current;
        if (!dialog) return undefined;
        const handleClose = () => onClose();
        dialog.addEventListener('close', handleClose);
        return () => dialog.removeEventListener('close', handleClose);
    }, [onClose]);

    useEffect(() => {
        const dialog = dialogRef.current;
        if (!dialog) return;
        if (open && !dialog.open) dialog.showModal();
        if (!open && dialog.open) dialog.close();
    }, [open]);

    const closeOnBackdrop = (event) => {
        const dialog = dialogRef.current;
        if (!dialog || event.target !== dialog) return;
        const rect = dialog.getBoundingClientRect();
        const outside = event.clientX < rect.left
            || event.clientX > rect.right
            || event.clientY < rect.top
            || event.clientY > rect.bottom;
        if (outside) dialog.close();
    };

    return (
        <dialog
            ref={dialogRef}
            id={id}
            className={className}
            aria-labelledby={labelledBy}
            onClick={closeOnBackdrop}
        >
            {children}
        </dialog>
    );
}

export default LandingDialog;
